export default __webpack_public_path__ + "static/bg-api-fa4ca0c3cbc3ce87a3a460d2dfc9fac9.jpg";